<template>
    <v-form v-if="Object.keys(model).length" id="priceStockForm" class="form form-horizontal with-divider">
        <!--当BD选择的POI，命中演出票白名单时，展示“产品类型设置模块”-->
        <fieldset :disabled="mode == 'readonly'" v-show="extra.isBD && extra.isDirectDeal && model.theatreWhiteList">
            <div class="legend">产品类型设置</div>
            <div class="form-group">
                <label class="control-label label-required col-lg-2 col-sm-3"><i
                        class="required-field">＊</i>产品类型设置</label>
                <div class="col-sm-8 pdt9">
                    <label><input type="radio" :disabled="!extra.isNew" v-model="model.ticketPriceType" name="ticketPriceType"
                                  value="0">
                        门票</label>
                    <label class="mgr10"><input :disabled="!extra.isNew" type="radio" v-model="model.ticketPriceType" name="ticketPriceType"
                                                value="1">
                        演出票</label>
                </div>
            </div>
            <div class="form-group" v-show="model.ticketPriceType==1">
                <label class="control-label label-required col-lg-2 col-sm-3"><i
                        class="required-field">＊</i>是否支持在线选座</label>
                <div class="col-sm-8 pdt9">
                    <label><input type="radio" v-model="model.canSeatSelection" name="canSeatSelection"
                                  value="true">
                        支持</label>
                    <label class="mgr10"><input type="radio" v-model="model.canSeatSelection" name="canSeatSelection"
                                                value="false">
                        不支持</label>
                </div>
            </div>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'" v-bind:class="{'tuan-field': isTuan}">
            <div class="legend" v-if="extra.isDirectDeal">有效期设置&nbsp;&nbsp;<span class="tip icon-info">重要提示：有效期模式一经设置不能修改，请在上单前与商家确认</span>
            </div>
            <div class="legend" v-else>有效期设置&nbsp;&nbsp;<span class="tip icon-info">重要提示：有效期模式设置后不能修改</span></div>
            <div class="form-group">
                <label class="control-label label-required col-lg-2 col-sm-3"><i
                    class="required-field">＊</i>{{model.IAmTheatre?'有效期设置':'日期设置'}}</label>
                <div class="col-sm-7 col-lg-8">
                    <!--剧场票只有价格日历模式-->
                    <div class="radio" v-show="!model.IAmTheatre">
                        <label>
                            <!-- 0 有效期模式 1 使用日期模式， 默认有效期模式-->
                            <input type="radio"
                                   value="0"
                                   v-model="model.useDateMode"
                                   :disabled="mode == 'edit'"
                                   @change="dateModeChange"
                                   name="dateMode"
                            >有效期模式，无需用户指定使用日期
                        </label>
                    </div>
                    <div class="radio">
                        <label>
                            <input type="radio"
                                   value="1"
                                   v-model="model.useDateMode"
                                   @change="dateModeChange"
                                   :disabled="mode == 'edit'"
                                   name="dateMode">
                            使用日期模式，需要用户指定使用日期，自所选日期起
                            <span class="inline-block input-w-3 relative">
                                <custom-input-number style="position: absolute;top:-26px" :min="1" :step="1"
                                                     :disabled="model.useDateMode==0"
                                                     v-model="model.useDateDays"></custom-input-number>
                        </span>
                            天内可使用
                        </label>
                        <span v-show="model.useDateMode==1 && !model.IAmTheatre" class="inline-block annotate">与无需指定日期相比，订单量约减少20%</span>
                    </div>
                    <p class="warning-msg" v-show="needValidation && model.useDateMode == 1 && !model.useDateDays">
                        请填写几日内可使用</p>
                </div>
            </div>
            <!---->
            <div v-if="model.useDateMode == 0 && !model.IAmTheatre">
                <div class="form-group"
                     fieldset-validator="'checkGroup'">
                    <label class="control-label label-require col-lg-2 col-sm-3"><i
                        class="required-field">＊</i>有效期时间段</label>
                    <div class="col-sm-8 input-w-4">
                        <!--:class="{'has-warning':model.useDateMode == 0 && !model.voucherDateBegin}"-->
                        <v-datepicker :message='voucherDateBeginEnd'
                                      :options='inDateOption'></v-datepicker>
                        <p class="warning-msg"
                           v-show="needValidation && model.useDateMode == 0 && !model.voucherDateBegin">请选择有效期时间段</p>
                    </div>
                </div>
                <div class="form-group"
                     ng-class="{'has-warning': (validWeekRuleForm.$invalid) && $ctrl.needValidation}">
                    <label class="control-label label-require col-lg-2 col-sm-3"><i
                        class="required-field">＊</i>可用日期</label>
                    <div class="col-sm-8">
                        <div class="checkbox-group pdt9">
                            <label v-for="i in weeks" :key="i.val">
                                <input type="checkbox"
                                       v-if="model.validWeekRule"
                                       v-model="model.validWeekRule[i.val]"
                                       value="true">{{i.text}}</label>
                            <label><input type="checkbox" v-model="validWeekCheckedAll"
                                          @change="selectAllWeek"
                                          value="true">全选</label>
                        </div>
                        <p class="warning-msg" v-show="needValidation && model.useDateMode == 0 && !hasWeekOne">
                            请选择可用日期</p>
                    </div>

                </div>
                <div class="form-group">
                    <label class="control-label col-lg-2 col-sm-3">不可用日期</label>
                    <div class="col-sm-4 bd minh249 pd10" style="margin-top: 1px;">
                    <span v-for="i in model.unavailableDates"
                          :class="{'disable-date':true,'mg10':true,'disabled': i<today}">{{i}}
                        <span class="del"
                              @click="mode!=='readonly' && deleteUnavailableDates(i)">x</span></span>
                    </div>
                    <div class="col-sm-4 no-input" v-if="!isTuan">
                        <custom-datepicker :message="unavailableDates"
                                           v-if="Object.keys(model).length"
                                           :options.sync='inDateOptionOpen'></custom-datepicker>
                        <div>
                            <button class="btn btn-link no-outline" type="button"
                                    @click="resetUnavailableDates">重置不可用日期
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <div v-show="!model.IAmTheatre">
            <div v-if="model.useDateMode == 0">
                <div class="legend">价格库存</div>
                <fieldset :disabled="mode == 'readonly' && !isTuan" style="border: none">
                    <div class="form-group">
                        <label class="control-label label-require col-lg-2 col-sm-3"><i
                            class="required-field">＊</i>库存模式</label>
                        <div class="col-sm-8 pdt9">
                            <label for="r11"><input :disabled="mode == 'readonly'" id="r11" type="radio" v-model="model.stockType" name="stockType"
                                                    value="1">
                                不限库存</label>
                            <label class="mgr10"><input :disabled="mode == 'readonly'" type="radio" v-model="model.stockType" name="stockType"
                                                        value="3">
                                总库存</label>
                            <span v-show="model.stockType==3">
                        剩余总库存
                    <span class="inline-block input-w-3 relative">
                         <custom-input-number style="position: absolute;top:-26px" :min="0" :step="1"
                                              v-model="model.stock"></custom-input-number>
                        </span>
                    张 已售{{model.sold || 0}}张
                    </span>
                            <p class="warning-msg" v-show="needValidation && model.stockType == 3 && !model.stock">
                                请填写剩余总库存</p>
                        </div>
                    </div>
                </fieldset>
                <fieldset :disabled="mode == 'readonly'">
                    <div class="form-group">
                        <label class="control-label label-require col-lg-2 col-sm-3"><i
                            class="required-field">＊</i>价格设置</label>
                        <div class="col-sm-8">
                            <div>
                                <table class="table table-bordered table-centered">
                                    <thead>
                                    <tr>
                                        <th>门市价(元)</th>
                                        <th>美团价(元)</th>
                                        <th>结算价(元)</th>
                                        <th>费率(%)</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <custom-input-number :placeholder="'请输入门市价'" :min="0" :step="0.01" :disabled="mode == 'readonly'"
                                                                 v-model="model.marketPrice"></custom-input-number>
                                        </td>
                                        <td>
                                            <custom-input-number :placeholder="'请输入美团价'" :min="0" :step="0.01" :disabled="mode == 'readonly'"
                                                                 v-model="model.mtPrice"></custom-input-number>
                                        <td>
                                            <custom-input-number :initAsNull="true" :placeholder="'请输入结算价'" :min="0" :disabled="mode == 'readonly'"
                                                                 :step="0.01"
                                                                 v-model="model.settlementPrice"></custom-input-number>
                                        <td class="disabled">
                                            <input :class="{'red':ratioInvalid,'no-border-input':true}" readonly
                                                   name="ratio" type="text"
                                                   v-model="ratioShow">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div class="red">
                                    <span v-show="model.mtPrice > model.marketPrice">美团价不能大于门市价</span>
                                    <span v-if="ratio > 50 || ratioInvalid==4">请确认您是否输入了正确的价格 {{ratioInvalid==4?'<'+(this.model.onlineMsRatioPriceInfo.oldMsRatio * 100) + '% 费率下降':''}}</span>
                                    <span v-show="model.settlementPrice && ratio < model.baseMsRatioSnapshot*100">
                                              重要提示：费率低于当前【{{model.maxMsRatioProvinceName}}】的底线费率{{model.baseMsRatioSnapshot*100}}%</span>
                                    </span>
                                </div>
                                <p class="warning-msg"
                                   v-show="needValidation && model.useDateMode == 0 && (!model.marketPrice || !model.mtPrice)">
                                    请填写价格信息</p>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div v-if="model.useDateMode != 0">
                <fieldset :disabled="mode == 'readonly'  && !isTuan">
                <div class="legend">价格库存</div>
                    <div class="form-group">
                        <label class="control-label label-require col-lg-2 col-sm-3"><i
                            class="required-field">＊</i>库存模式</label>
                        <div class="col-sm-8 pdt9">
                            <label for="r11"><input type="radio" :disabled="mode == 'readonly'" v-model="model.stockType" name="stockType" value="1">
                                不限库存</label>
                            <label class="mgr10"><input type="radio" :disabled="mode == 'readonly'" v-model="model.stockType" name="stockType"
                                                        value="3">
                                总库存</label>
                            <label class="mgr10">
                                <!--:disabled="model.stockType == 3"-->
                                <input :disabled="mode == 'readonly'" type="radio"
                                       v-model="model.stockType"
                                       name="stockType" value="2">
                                日库存</label>
                            <span v-show="model.stockType==3">
                        剩余总库存
                    <span class="inline-block input-w-3 relative">
                        <custom-input-number style="position: absolute;top:-26px" :min="0" :step="1"
                                             v-model="model.stock"></custom-input-number>
                        </span>
                    张 已售 {{model.sold || 0}} 张
                    </span>
                            <p class="warning-msg" v-show="needValidation && model.stockType == 3 && !model.stock">
                                请填写剩余总库存</p>
                        </div>
                    </div>
                </fieldset>
                <fieldset :disabled="mode == 'readonly' && !isTuan" style="border: none">
                    <div class="form-group">
                        <label class="control-label label-require col-lg-2 col-sm-3">
                            <button v-if="canPullPrice && model.useDateMode == 1"
                                    class="btn btn-primary pull-price-button" type="button" @click="pullPrice(true)">
                                拉取价格信息
                            </button>
                            <i class="required-field">＊</i>日期价格</label>
                        <div class="col-sm-9">
                            <label class="control-label label-require"><i
                                class="required-field">＊</i>请先选择日期</label>
                            <Calendar :selected.sync="dateSelected" :single="false"
                                      @calendar-remove-selected="onRemoveDate"
                                      :lock-check="dayLock.bind(this)"
                                      :readonly="mode == 'readonly'"
                                      :isTuan="isTuan"
                                      :get-day-info="getInfoFun.bind(this)" :before-time="today"></Calendar>
                        </div>
                        <div class="col-sm-9 col-md-offset-2" style="padding: 0;padding-top:10px;" v-if="!isTuan">
                            <div style="margin-left: 13px" v-if="!(canPullPrice && model.useDateMode == 1)"><i
                                class="required-field">＊</i>价格设置
                            </div>
                            <div class="col-sm-10">
                                <table class="table table-bordered table-centered"
                                       v-if="!(canPullPrice && model.useDateMode == 1)">
                                    <thead>
                                    <tr>
                                        <th>门市价(元)</th>
                                        <th>美团价(元)</th>
                                        <th>结算价(元)</th>
                                        <th>费率(%)</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <custom-input-number :placeholder="'请输入门市价'" :min="0" :step="0.01" :disabled="mode == 'readonly'"
                                                                 v-model="modelLocal.marketPrice"></custom-input-number>

                                        </td>

                                        <td>
                                            <custom-input-number :placeholder="'请输入美团价'" :min="0" :step="0.01" :disabled="mode == 'readonly'"
                                                                 v-model="modelLocal.mtPrice"></custom-input-number>

                                        </td>
                                        <td>
                                            <custom-input-number :placeholder="'请输入结算价'" :min="0" :step="0.01" :disabled="mode == 'readonly'"
                                                                 v-model="modelLocal.settlementPrice"
                                                                 :initAsNull="true"></custom-input-number>
                                        </td>
                                        <td class="disabled">
                                            <input :class="{'red':ratioInvalid || belowBase,'no-border-input':true}"
                                                   readonly
                                                   name="ratio" type="text"
                                                   v-model="ratioShowLocal"></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div class="red">
                                    <span v-if="ratioLocal > 50 || modelLocal.settlementPrice && hasDeclined">请确认您是否输入了正确的价格 {{modelLocal.settlementPrice && hasDeclined? '费率下降':''}}</span>
                                    <span v-show="modelLocal.mtPrice > modelLocal.marketPrice">美团价不能大于门市价</span>
                                    <span
                                        v-show="modelLocal.settlementPrice && ratioLocal < model.baseMsRatioSnapshot * 100">
                                              低于当前【{{model.maxMsRatioProvinceName}}】的底线费率{{model.baseMsRatioSnapshot*100}}%</span>
                                </div>
                                <table class="table table-bordered table-centered" v-if="belowBase">
                                    <thead>
                                    <tr>
                                        <th class="text-center" colspan="3">
                                            特殊费率详细信息
                                            <span class="red">当前【{{model.maxMsRatioProvinceName}}】底线费率{{model.baseMsRatioSnapshot*100}}%</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>日期</th>
                                        <th>美团价</th>
                                        <th>费率</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="group in invalidRatioList">
                                        <td>
                                            <ul class="list-unstyled">
                                                <li v-for="item in group.dates">{{item}}</li>
                                            </ul>
                                        </td>
                                        <td>
                                            {{group.mtPrice}}
                                        </td>
                                        <td>
                                            {{group.ratio}}%
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-offset-2 pdt9" v-if="!(canPullPrice && model.useDateMode == 1)">
                        <span v-show="model.stockType==2">
                          <i class="required-field">＊</i>剩余日库存
                         <span class="inline-block input-w-3 relative">
                             <custom-input-number style="position: absolute;top:-26px" :min="0" :step="1"
                                                  v-model="modelLocal.stock"></custom-input-number>
                         </span>
                        张 &nbsp;
                        </span>
                            <button class="btn btn-primary" type="button"
                                    :disabled="!modelLocal.marketPrice || !modelLocal.mtPrice || modelLocal.settlementPrice == undefined"
                                    @click="addDayPrice(modelLocal, dateSelected)"
                                    v-if="!readonly || isTuan">更新
                            </button>

                        </div>
                    </div>
                </fieldset>
            </div>
            <!--免票-->
            <fieldset :disabled="mode == 'readonly'" style="border: none">
                <div class="form-group"
                     v-show="(model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket">
                    <label class="control-label label-require col-lg-2 col-sm-3"><i
                        class="required-field">＊</i>免票类型</label>
                    <div class="col-sm-2">
                        <v-select v-model="model.freeTicketType"
                                  @change="updateFreeType"
                                  :clearable="false" size="md"
                                  placeholder="请选择">
                            <v-option v-for="item in freeTicketTypes" :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                            </v-option>
                        </v-select>
                    </div>
                    <div v-show="model.freeTicketType==0">
                        <label class="control-label label-require col-lg-2 col-sm-3"><i
                            class="required-field">＊</i>关联账单</label>
                        <div class="col-sm-2">
                            <v-select v-model="model.statementId"
                                      :class="{'has-warning':!model.statementId}"
                                      @change="updateStatements"
                                      :clearable="false" size="md"
                                      placeholder="请选择">
                                <v-option v-for="item in model.associatedContractList" :key="item.statementId"
                                          :label="item.showName"
                                          :value="item.statementId+''">
                                </v-option>
                            </v-select>
                        </div>
                    </div>
                    <div v-show="model.freeTicketType==1">
                        <label class="control-label label-require col-lg-2 col-sm-3"><i
                            class="required-field">＊</i>关联广告合同编号</label>
                        <div class="col-sm-2">
                            <input type="text"
                                   name="freeTicketAssociatedAccount"
                                   class="form-control"
                                   id="freeTicketAssociatedAccount"
                                   v-model="model.freeTicketAssociatedAccount"
                                   placeholder="关联合同编号">
                        </div>
                    </div>
                </div>
                <p style="padding-left: 15px;" class="warning-msg  col-lg-offset-2 col-sm-offset-3"
                   v-show="needValidation && ((model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket) && (model.freeTicketType==null || model.freeTicketType==undefined)">
                    请选择免票类型</p>
                <div class="form-group"
                     v-show="(model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket">
                    <label class="control-label label-require col-lg-2 col-sm-3"><i
                        class="required-field" v-show="model.freeTicketType == 4">＊</i>免票备注</label>
                    <div class="col-sm-8">
                    <textarea class="form-control"
                              name="freeTicketRemarks"
                              id="include"
                              cols="30"
                              rows="5"
                              v-model="model.freeTicketRemarks"
                              placeholder="请填写免票备注的详细信息"></textarea>
                        <p class="warning-msg"
                           v-show="needValidation && ((model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket) && model.freeTicketType == 4">
                            请填写免票备注</p>
                    </div>
                </div>
                <!-- 特殊费率原因 -->
                <div class="form-group"
                     v-if="(model.useDateMode ==0 && (ratioInvalid==4 || ratioInvalid==3)) || (model.useDateMode ==1 && (hasDeclined || belowBase))">
                    <label class="col-xs-2 control-label label-require"><i
                        class="required-field">＊</i>特殊费率原因：</label>
                    <div class="col-xs-8">
                        <div class="form-group">
                            <table class="rate-reason margin-left15">
                                <tbody>
                                <tr>
                                    <td>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       name="specialMsRatioReasonType"
                                                       value="1"
                                                       v-model="model.specialMsRatioReasonType"
                                                >同行价格劣势竞争
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       name="specialMsRatioReasonType"
                                                       value="2"
                                                       v-model="model.specialMsRatioReasonType"
                                                >独家优势方案、资源、票种
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       name="specialMsRatioReasonType"
                                                       value="3"
                                                       v-model="model.specialMsRatioReasonType"
                                                >结算价格不变且无法使用促销
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="radio">
                                            <label>
                                                <input type="radio"
                                                       name="specialMsRatioReasonType"
                                                       value="4"
                                                       v-model="model.specialMsRatioReasonType"
                                                >其他（请在下方文本框中填写理由）
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-group" v-show="model.specialMsRatioReasonType == '4'">
                        <textarea class="form-control"
                                  required
                                  rows="3"
                                  maxlength="100"
                                  v-model="model.specialMsRatioReason"
                                  placeholder="请填写特殊费率原因"></textarea>
                            <span :class="{red:model.specialMsRatioReason.length==100}">{{model.specialMsRatioReason.length || 0}}/100字</span>
                        </div>
                        <p class="warning-msg"
                           v-show="needValidation && model.specialMsRatioReasonType == '4' && !model.specialMsRatioReason">
                            请填写特殊费率原因</p>
                    </div>
                </div>
            </fieldset>
        </div>
        <div v-show="model.IAmTheatre">
            <fieldset :disabled="mode == 'readonly'">
                <div class="legend">演出设置
                </div>
                <div class="form-group" style="margin-top: -50px;">
                    <div class="col-sm-8 col-sm-offset-1">
                        <button class="btn btn-primary" :disabled="!(extra.partnerDealId && extra.supplierId)" type="button" @click="fetchTheatreInfo(true)">拉取演出信息</button>
                        <!--:active-name="activeIndex"-->
                        <v-tabs @tab-click="" class="no-fixed" type="panels">
                            <v-tab-pane label="1.价格日历">
                                <Calendar :selected.sync="price.dateSelected"
                                          :single="!price.canEditPrice"
                                          :lock-check="dayLock.bind(this)"
                                          :on-single-select="price.onDaySelect"
                                          :readonly="mode == 'readonly' && false"
                                          :get-day-info="price.getInfoFun.bind(this)" :before-time="today"></Calendar>
                                <div v-if="mode == 'edit' || mode == 'readonly' || mode == 'new' || mode == 'copy'">
                                    <div>
                                        <p>{{!price.canEditPrice && !price.dateSelected.length?'请选择日期以查看价格':'' }}</p>
                                        <b>{{!price.canEditPrice && price.dateSelected.length ? '已选择：'+price.dateSelected[0]:
                                            ''}}</b>
                                        <b>{{price.canEditPrice?'已选择: '+price.dateSelected.length+'天':''}}</b>
                                    </div>
                                </div>
                                <table class="table table-bordered table-centered input-table">
                                    <thead>
                                    <tr>
                                        <th>市场价(元)</th>
                                        <th>美团价(元)</th>
                                        <th>结算价(元)</th>
                                        <th>费率(%)</th>
                                        <th>价格说明</th>
                                    </tr>
                                    </thead>
                                    <tbody class="juchang">
                                    <tr v-for="item in price.priceTable" :key="item.id">
                                        <td>
                                            <custom-input-number :placeholder="'请输入门市价'" :min="0" :step="0.01"
                                                                 :disabled="!price.canEditPrice"
                                                                 v-model="item.marketPrice"></custom-input-number>
                                        </td>
                                        <td>
                                            <custom-input-number :placeholder="'请输入美团价'" :min="0" :step="0.01"
                                                                 :disabled="!price.canEditPrice"
                                                                 v-model="item.mtPrice"></custom-input-number>
                                        </td>
                                        <td>
                                            <custom-input-number :placeholder="'请输入结算价'" :min="0"
                                                                 :disabled="!price.canEditPrice"
                                                                 :step="0.01"
                                                                 v-model="item.settlementPrice"></custom-input-number>
                                        </td>
                                        <td class="disabled">
                                            {{correctRatio(item.mtPrice, item.settlementPrice)}}
                                        </td>
                                        <td class="disabled">
                                            {{item.priceDesc}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <p v-show="mode == 'edit' || mode == 'new' || mode == 'copy' || mode == 'readonly'">
                                    <button class="btn btn-primary" type="button"
                                            :disabled="mode == 'readonly'"
                                            v-show="!price.canEditPrice"
                                            @click="price.canEditPrice = true;">编辑
                                    </button>
                                    <button class="btn btn-default" type="button"
                                            v-show="price.canEditPrice"
                                            @click="price.cancelCanEdit">取消
                                    </button>
                                    <button class="btn btn-primary" type="button"
                                            v-show="price.canEditPrice"
                                            @click="price.savePrice">保存
                                    </button>
                                </p>
                            </v-tab-pane>
                            <v-tab-pane label="2.场次信息" :hidden="!theatreTab.changci">
                                <Calendar :selected.sync="changci.dateSelected"
                                          :single="!changci.canEditPrice"
                                          :lock-check="dayLock.bind(this)"
                                          :on-single-select="changci.onDaySelect"
                                          :readonly="mode == 'readonly' && false"
                                          :get-day-info="changci.getInfoFun.bind(this)" :before-time="today"></Calendar>
                                <div v-if="mode == 'edit' || mode == 'new' || mode == 'readonly' || mode == 'copy'">
                                    <div>
                                    <p>{{!changci.canEditPrice && !changci.dateSelected.length?'请选择日期以查看场次信息':'' }}</p>
                                    <b>{{!changci.canEditPrice && changci.dateSelected.length ? '已选择：'+changci.dateSelected[0]:
                                        ''}}</b>
                                    <b>{{changci.canEditPrice?'已选择: '+changci.dateSelected.length+'天':''}}</b>
                                    </div>
                                </div>
                                <table class="table table-bordered table-centered">
                                    <thead>
                                    <tr>
                                        <th>场次信息</th>
                                        <th>场次开始时间</th>
                                    </tr>
                                    </thead>
                                    <tbody class="juchang">
                                    <tr v-for="item in changci.priceTable" :key="item.id">
                                        <td>
                                            <v-input placeholder="'请输入场次信息'"
                                                                 :disabled="!changci.canEditPrice"
                                                                 v-model="item.levelName"/>
                                        </td>
                                        <td>
                                            {{item.mappingRel}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div @click="sortDialog.sort('changci')" class="sort-dialog">调整顺序<span class="sort-icon"></span></div>
                                <p>
                                    <button class="btn btn-primary" type="button"
                                            :disabled="mode == 'readonly'"
                                            v-show="!changci.canEditPrice"
                                            @click="changci.canEditPrice = true;">编辑
                                    </button>
                                    <button class="btn btn-default" type="button"
                                            v-show="changci.canEditPrice"
                                            @click="changci.cancelCanEdit">取消
                                    </button>
                                    <button class="btn btn-primary" type="button"
                                            v-show="changci.canEditPrice"
                                            @click="changci.savePrice">保存
                                    </button>
                                </p>
                            </v-tab-pane>
                            <v-tab-pane label="3.席位信息" :hidden="!theatreTab.xiwei">
                                <Calendar :selected.sync="xiwei.dateSelected"
                                          :single="!xiwei.canEditPrice"
                                          :lock-check="dayLock.bind(this)"
                                          :on-single-select="xiwei.onDaySelect"
                                          :readonly="mode == 'readonly' && false"
                                          :get-day-info="xiwei.getInfoFun.bind(this)" :before-time="today"></Calendar>
                                <div v-if="mode == 'edit' || mode == 'new' || mode == 'readonly' || mode == 'copy'">
                                    <div>
                                        <p>{{!xiwei.canEditPrice && !xiwei.dateSelected.length?'请选择日期以查看席位信息':'' }}</p>
                                        <b>{{!xiwei.canEditPrice && xiwei.dateSelected.length ? '已选择：'+xiwei.dateSelected[0]:
                                            ''}}</b>
                                        <b>{{xiwei.canEditPrice?'已选择: '+xiwei.dateSelected.length+'天':''}}</b>
                                    </div>
                                </div>
                                <table class="table table-bordered table-centered">
                                    <thead>
                                    <tr>
                                        <th>坐席信息</th>
                                        <th>坐席位置</th>
                                    </tr>
                                    </thead>
                                    <tbody class="juchang">
                                    <tr v-for="item in xiwei.priceTable" :key="item.id">
                                        <td>
                                            <v-input placeholder="'请输入席位信息'"
                                                     :disabled="!xiwei.canEditPrice"
                                                     v-model="item.levelName"/>
                                        </td>
                                        <td>
                                            {{item.mappingRel}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!--icon-unsorted-->
                                <div @click="sortDialog.sort('xiwei')" class="sort-dialog">调整顺序<span class="sort-icon"></span></div>
                                <p>
                                    <button class="btn btn-primary" type="button"
                                            :disabled="mode == 'readonly'"
                                            v-show="!xiwei.canEditPrice"
                                            @click="xiwei.canEditPrice = true;">编辑
                                    </button>
                                    <button class="btn btn-default" type="button"
                                            v-show="xiwei.canEditPrice"
                                            @click="xiwei.cancelCanEdit">取消
                                    </button>
                                    <button class="btn btn-primary" type="button"
                                            v-show="xiwei.canEditPrice"
                                            @click="xiwei.savePrice">保存
                                    </button>
                                </p>
                            </v-tab-pane>
                            <v-tab-pane label="4.场馆区域" :hidden="!theatreTab.changguan">
                                <Calendar :selected.sync="changguan.dateSelected"
                                          :single="!changguan.canEditPrice"
                                          :lock-check="dayLock.bind(this)"
                                          :on-single-select="changguan.onDaySelect"
                                          :readonly="mode == 'readonly' && false"
                                          :get-day-info="changguan.getInfoFun.bind(this)" :before-time="today"></Calendar>
                                <div v-if="mode == 'edit' || mode == 'new' || mode == 'readonly' || mode == 'copy'">
                                    <div>
                                        <p>{{!changguan.canEditPrice && !changguan.dateSelected.length?'请选择日期以查看场馆信息':'' }}</p>
                                        <b>{{!changguan.canEditPrice && changguan.dateSelected.length ? '已选择：'+changguan.dateSelected[0]:
                                            ''}}</b>
                                        <b>{{changguan.canEditPrice?'已选择: '+changguan.dateSelected.length+'天':''}}</b>
                                    </div>
                                </div>
                                <table class="table table-bordered table-centered">
                                    <thead>
                                    <tr>
                                        <th>场馆区域信息</th>
                                        <th>场馆位置</th>
                                    </tr>
                                    </thead>
                                    <tbody class="juchang">
                                    <tr v-for="item in changguan.priceTable" :key="item.id">
                                        <td>
                                            <v-input placeholder="'请输入场馆区域信息'"
                                                     :disabled="!changguan.canEditPric"
                                                     v-model="item.levelName"/>
                                        </td>
                                        <td>
                                            {{item.mappingRel}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div @click="sortDialog.sort('changguan')" class="sort-dialog">调整顺序<span class="sort-icon"></span></div>
                                <p>
                                    <button class="btn btn-primary" type="button"
                                            :disabled="mode == 'readonly'"
                                            v-show="!changguan.canEditPrice"
                                            @click="changguan.canEditPrice = true;">编辑
                                    </button>
                                    <button class="btn btn-default" type="button"
                                            v-show="changguan.canEditPrice"
                                            @click="changguan.cancelCanEdit">取消
                                    </button>
                                    <button class="btn btn-primary" type="button"
                                            v-show="changguan.canEditPrice"
                                            @click="changguan.savePrice">保存
                                    </button>
                                </p>
                            </v-tab-pane>
                        </v-tabs>
                    </div>
                </div>
            </fieldset>
            <fieldset :disabled="mode=='readonly'">
                <div class="legend">座位图片</div>
                <div class="form-group">
                    <div class="col-sm-8 col-sm-offset-1">
                        <div class="pdt9">
                            <custom-upload
                                    :url="seatUpload.url"
                                    :file-name="'file'"
                                    :is-multiple="false"
                                    :max-limit="seatUpload.maxImgLength"
                                    :thumbnail-mode="true"
                                    :show-file-list="false"
                                    :type="'imageList'"
                                    :default-file-list="model.seatImageShow"
                                    :fileLimitSize=2097152
                                    :enable-head-image="false"
                                    :accept="'image/jpg,image/jpeg,image/png'"
                                    @on-max-limit="seatUpload.onMaxLimit"
                                    @on-success="seatUpload.onSuccess"
                                    @on-delete="seatUpload.onDelete"
                                    @on-file-size-max-limit="seatUpload.onSizeLimited"
                            >
                            </custom-upload>
                        </div>
                        <section>
                            <div class="pdt9 lh14">
                                <b>注意事项：</b><br>
                                <span class="annotate">
                                      1. 高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg<br>
                                2. 重要提示：图片不可有字、不可使用拼图、不可有重复图片、不可有除美团水印外的其他水印、不能有人物特写、明星宣传画等涉及人物肖像权的图片<br>
                                </span>
                            </div>
                        </section>
                    </div>
                </div>
            </fieldset>
        </div>
        <refund :model="model"
                :mode="mode"
                :isTuan="isTuan"
                :extra="extra">

        </refund>
        <fieldset :disabled="mode == 'readonly' && !isTuan">
            <div class="legend">上下架控制/其他信息</div>
            <div class="form-group">
                <label class="col-lg-2 col-sm-3 control-label label-require">
                    <i class="required-field">＊</i>上架时间
                </label>
                <div class="col-sm-8">
                    <div class="radio">
                        <label for="AuditPassOnline">
                            <input :disabled="mode == 'readonly'" id="AuditPassOnline" type="radio" required name="scheduleOnlineType" value="1"
                                   v-model="model.scheduleOnlineType">
                            审核通过自动上架</label>
                    </div>
                    <div class="radio">
                        <label for="periodOfValidityOnline">
                            <input :disabled="mode == 'readonly'" id="periodOfValidityOnline" type="radio" required name="scheduleOnlineType"
                                   value="2" v-model="model.scheduleOnlineType">
                            有效期始自动上架</label>
                    </div>
                    <div class="radio">
                        <label>
                            <input :disabled="mode == 'readonly'" type="radio" required name="scheduleOnlineType" value="3"
                                   v-model="model.scheduleOnlineType">
                            手动上架</label>
                    </div>
                    <div class="radio" style="margin-top: -8px;">
                        <label for="specifyDateOnline">
                            <input :disabled="mode == 'readonly'" id="specifyDateOnline" type="radio" required name="scheduleOnlineType" value="4"
                                   v-model="model.scheduleOnlineType">
                            指定日期上架
                        </label>
                        <div class="w200 inline-block">
                            <v-datepicker :message='model.scheduleOnlineTime'
                                          :disabled="model.scheduleOnlineType != 4"
                                          v-model="model.scheduleOnlineTime"></v-datepicker>
                        </div>

                    </div>
                    <p class="warning-msg"
                       v-show="needValidation && model.scheduleOnlineType==4 && !model.scheduleOnlineTime">请选择上架日期</p>
                </div>
            </div>
            <div class="form-group">
                <label class="col-lg-2 col-sm-3 control-label label-require">
                    <i class="required-field">＊</i>
                    下架时间
                </label>
                <div class="col-sm-8">
                    <div class="radio">
                        <label>
                            <input :disabled="mode == 'readonly' && !isTuan" type="radio" required name="scheduleOfflineType" value="1"
                                   v-model="model.scheduleOfflineType">
                            {{model.useDateMode==0?'有效期':'价格日历期限'}}已过自动下架</label>
                    </div>
                    <div class="radio" style="margin-top: -8px;">
                        <label>
                            <input :disabled="mode == 'readonly' && !isTuan" type="radio" name="scheduleOfflineType" value="2"
                                   v-model="model.scheduleOfflineType">
                            指定下架时间</label>
                        <div class="w200 inline-block">
                            <v-datepicker :message='model.scheduleOfflineTime'
                                          :disabled="model.scheduleOfflineType == 1 || (mode == 'readonly' && !isTuan)"
                                          v-model="model.scheduleOfflineTime"></v-datepicker>
                        </div>
                        <input readonly disabled class="input-w-3 inline-block" type="text" name="scheduleOfflineType"
                               value="00:00">
                    </div>
                    <p class="warning-msg"
                       v-show="needValidation && model.scheduleOfflineType==2 && !model.scheduleOfflineTime">请选择下架日期</p>

                </div>
            </div>
        </fieldset>
        <fieldset :disabled="mode == 'readonly'">
            <div class="form-group" v-show="extra.isBD || model.IAmTheatre">
                <label class="col-lg-2 col-sm-3 control-label label-require">
                    <i class="required-field">＊</i>
                    是否单独售卖
                </label>
                <div class="col-sm-8">
                    <div class="radio">
                        <label>
                            <input type="radio" required name="sellType" value="1"
                                   v-model="model.sellType">
                            可单独售卖</label>
                    </div>
                    <div class="radio" style="margin-top: -8px;">
                        <label>
                            <input id="ManualOnline222" type="radio" required name="sellType" value="2"
                                   v-model="model.sellType">
                            用于打包，不可单独售卖</label>
                        <span class="annotate" v-show="model.sellType==2">选择后, 产品不会被用户看到和单独购买。支持单独售卖的产品请勿选</span>
                    </div>
                </div>
            </div>
            <!--当费率为0，需要上传特批附件-->
            <div class="form-group" v-show="!model.IAmTheatre && extra.isBD">
                <label class="col-lg-2 col-sm-3 control-label label-require">
                    <i class="required-field">＊</i>
                    是否上传附件
                </label>
                <div class="col-sm-8">
                    <div class="radio">
                        <label>
                            <input type="radio" required name="needSpecialAuthFile" value="true"
                                   v-model="model.needSpecialAuthFile">
                            需要</label>
                    </div>
                    <div class="radio" style="margin-top: -8px;">
                        <label>
                            <input type="radio" required name="needSpecialAuthFile" value="false"
                                   v-model="model.needSpecialAuthFile">
                            不需要</label>
                    </div>
                    <section v-show="model.needSpecialAuthFile==='true' || model.needSpecialAuthFile===true">
                        <div class="pdt9 tip icon-info lh14">
                            重要提示：<br> &nbsp;&nbsp;
                            1. 请将已走完特批流程的截图上传附件；若特批流程未完成，不能提交审核；<br> &nbsp;&nbsp;
                            2. 上传的附件名称需与特批流程名称一致，若流程中有多图，请为图片增加序号以明确顺序（如，二次预约特批-1.ipg）<br>
                        </div>
                        <div class="pdt9">
                            <!--<v-button type="primary" size="md" href="javascript:;">上传图片</v-button>-->
                            <custom-upload
                                    :url="upload.url"
                                    :file-name="'file'"
                                    :is-multiple="false"
                                    :max-limit="upload.maxImgLength"
                                    :thumbnail-mode="true"
                                    :show-file-list="false"
                                    :type="'imageList'"
                                    :default-file-list="model.specialAuthPicsShow"
                                    :fileLimitSize=2097152
                                    :enable-head-image="false"
                                    @on-max-limit="upload.onMaxLimit"
                                    @on-error="upload.onError"
                                    @on-success="upload.onSuccess"
                                    @on-delete="upload.onDelete"
                                    @on-file-size-max-limit="upload.onSizeLimited"
                            >
                            </custom-upload>
                        </div>
                        <!--{{model.specialAuthPics}}-->
                        <p class="warning-msg"
                           v-show="needValidation && extra.isBD && model.needSpecialAuthFile=='true' && model.specialAuthPics.length < 1">
                            请上传附件</p>
                    </section>
                </div>
            </div>
            <div class="form-group"
                 v-if="!model.IAmTheatre && (extra.isBD || account.accountType == 1) && subAccounts.length">
                <label class="col-xs-2 control-label">关联子账号:</label>
                <div class="col-xs-8 col-item">
                    <label v-for="subAccount in subAccounts"
                           v-if="ticketSubAccount(subAccount, 'all')">
                        <input type="checkbox" checked disabled
                               :title="subAccount.accountName"/>
                        {{subAccount.accountName}}
                    </label>
                    <template v-for="subAccount in subAccounts" v-if="ticketSubAccount(subAccount, 'single')">
                        <label>
                            <input type="checkbox"
                                   :disabled="subAccount.accountId == account.userId"
                                   :value="subAccount.accountId"
                                   v-model="model.bindedBizAccountId"
                                   :title="subAccount.accountName"/>
                            {{subAccount.accountName}}
                        </label>
                    </template>
                    <label>
                        <button class="btn btn-link no-outline" type="button"
                                @click="selectAllAccounts(subAccountAll)">全选
                        </button>
                    </label>
                    <div class="annotate">
                        被选中的子账号,将根据权限设置结果,对该产品拥有上单或验证权限
                    </div>
                </div>
            </div>
        </fieldset>
        <div class="bottom-filled"></div>
        <sort-dialog :model="sortDialog.model" :show.sync="sortDialog.show" @saveSort="sortDialog.save">

        </sort-dialog>
    </v-form>
</template>
<style lang='scss' rel="stylesheet/scss">
    $gray-base: #000 !default;
    $warning-color: #f76120;
    $main-color: #3dc6b6;
    $gray: lighten($gray-base, 33.5%) !default; // #555
    $table-border-color: #eaeaea !default; //** Text muted color
    $border-radius-base: 2px !default;
    $warning-text: #f76120 !default;
    $tip-color: #f58423;

    .form {
        fieldset {
            padding-top: 30px;
            border-top: 1px solid #ccd2df;
            /*&:last-of-type {*/
            /*border-bottom: none;*/
            /*}*/
            .legend {
                border-bottom: none;
                padding: 0 20px 12px 0;
                margin-bottom: 20px;
                color: #666666;
                font-size: 20px;
                font-weight: normal;
                line-height: 1;
                &.with-dot-line {
                    border-bottom: 2px dotted #d8d5d5;
                }
            }
            .disable-date {
                cursor: pointer;
                padding: 8px;
                border: 1px solid $main-color;
                color: $main-color;
                position: relative;
                display: inline-block;
                &.disabled {
                    color: #c6c6c6;
                    background-color: #f7f7f7;
                    border: solid 0.5px #d4d4d4;
                }
                .del {
                    position: absolute;
                    right: 3px;
                    top: -4px;
                    color: #ed001d;
                }
            }
        }

        &.with-divider {
            padding-bottom: 30px;
            margin-bottom: 30px;
        }

        .no-input {
            input {
                display: none !important;
            }
        }
    }

    .no-pdl {
        padding-left: 0;
    }

    .relative {
        position: relative;
    }

    .annotate {
        font-size: 12px;
        color: #666;
    }

    .red {
        color: #ff4f28 !important;
    }

    .required-field {
        display: inline-block;
        color: #ff4f28;
        font-size: 0;
        &:after {
            content: "*";
            display: inline-block;
            margin-right: 3px;
            font-size: 16px;
            font-weight: 400;
            color: #ff4f28;
        }
    }

    .yellow-tip {
        color: $main-color;
        padding: 10px 0;
    }

    .tip {
        color: $tip-color;
        font-size: 12px;
    }

    .checkbox-inline, .radio-inline {
        position: relative;
        display: inline-block;
        padding-left: 20px;
        margin-bottom: 0;
        vertical-align: middle;
        font-weight: 400;
        cursor: pointer;
    }

    .input-w-3 {
        width: 65px !important;
    }

    .input-w-4 {
        width: 250px !important;
    }

    .inline-block {
        display: inline-block !important;
    }

    .pdt9 {
        padding-top: 9px;
    }

    .pd10 {
        padding: 10px;
    }

    .mg10 {
        margin: 10px;
    }

    .mgr10 {
        margin-right: 10px;
    }

    w200 {
        width: 200px;
    }

    .bd {
        border: 1px solid $table-border-color;
    }

    .black {
        color: black;
    }

    .minh249 {
        min-height: 249px !important;
    }

    .lh14 {
        line-height: 1.428571429;
    }

    /*以下为priceTabel*/
    $font-size-base: 14px !default;
    $line-height-base: 1.428571429 !default; // 20/14
    $padding-base-vertical: 9px !default;
    $padding-base-horizontal: 13px !default;
    $line-height-computed: floor(($font-size-base * $line-height-base)) !default; // ~20px
    $input-height-base: ($line-height-computed + ($padding-base-vertical * 2) + 2) !default; //** Large `.form-control` height
    .price-mode-select {
        margin-bottom: 10px;
    }

    .input-table.table {
        tbody {
            td {
                padding: 0;
                .inline-remove-button {
                    margin: 0;
                }
                &.disabled {
                    background: #fafafa;
                    .no-border-input {
                        background: #f2f2f2;
                    }
                }
            }
        }
    }

    .no-border-input {
        border: none;
        outline: 0;
        height: $input-height-base; // Make inputs at least the height of their button counterpart (base line-height + padding + border)
        padding: $padding-base-vertical $padding-base-horizontal;
        font-size: $font-size-base;
        line-height: $line-height-base;
        border-radius: 0;
        &:focus {
            border: 0;
            outline: 0;
        }
    }

    .has-warning {
        border-color: #f76120 !important;
    }

    .warning-msg {
        color: #f76120 !important;
    }

    .no-fixed ul.nav-tabs {
        position: static !important;
    }

    .juchang .custom-input-group-width {
        width: 80%;
        display: inline-block;
        &:before {
            content: "￥";
            width: 9px;
            position: absolute;
            transform: translate(0, 50%);
            left: -15px;
        }
    }
    .sort-dialog {
        color: $main-color;
        text-align: right;
        padding: 10px;
        cursor: pointer;
    }
    .sort-icon {
        display: inline-block;
        vertical-align: middle;
        background-size: contain;
        background-repeat: no-repeat;
        width: 10px;
        height: 10px;
        // p0.meituan.net/codeman/8cce309527c338266a89f52a9b8a16341836.png
        background-image: url(//p0.meituan.net/codeman/80924ee084fb7bfe59b75c379bddf8874305.png);
    }
    .pull-price-button {
        position: absolute;
        margin-left: -20px;
        top: 50px;
    }
    .tuan-field {
        border-top: none !important;
        padding-top: 0 !important;
    }
</style>

<script type="text/babel">
    import {formatDate, eventBus} from 'helpers';
    import Big from 'big.js';
    import CustomInputNumber from 'components/input-number-custom/index.vue'
    import Calendar from 'components/calendar/Calendar.vue';
    import {mapGetters} from 'vuex';
    import {apiHost} from 'config/env.conf';
    import {getSubAccounts, getCommissionStatement, uploadImage, getPriceBase, savePriceBase, saveMappingExt, getAllMappingExtType, getMappingExt, saveMappingSort, getMappingSort, queryCalendar, asyncTicket} from 'api/ticket';
    import CustomUpload from 'components/custom-upload/upload.vue';
    import customDatepicker from 'components/datepicker/index';
    import SortDialog from 'components/product/sortDialog.vue';
    import Refund from 'components/product/refund.vue';
    export default {
        components: {
            Calendar,
            CustomUpload,
            CustomInputNumber,
            customDatepicker,
            SortDialog,
            Refund
        },
        directives: {},
        data () {
            let that = this;
            return {
                // 是否有价格日历
                canPullPrice: false,
                // 是否需要校验
                needValidation: true,
                // 可用日期选择，是否至少有一个选择了
                hasWeekOne: true,
                // 特殊费率
                ratioInvalid: false,
                modelLocal: {mtPrice: null, marketPrice: null, settlementPrice: null, stock: null},
                // 子账户
                subAccounts: [],
                // 全选子账户
                subAccountAll: false,
                // 有效期时间段日期组件配置
                inDateOption: {
                    allowInput: false,
                    mode: 'range',
                    minDate: formatDate(new Date(), 'yyyy-MM-dd'),
                    onChange: (dates) => {
                        let beginDate = null;
                        let endDate = null;
                        dates = dates.length ? dates : this.voucherDateBeginEnd.split(' ~ ');
                        if (dates && dates.length > 1) {
                            this.model.voucherDateBegin = formatDate(dates[0], 'yyyy-MM-dd');
                            this.model.voucherDateEnd = formatDate(dates[1], 'yyyy-MM-dd');
                            beginDate = this.model.voucherDateBegin;
                            endDate = this.model.voucherDateEnd;
                            // 删除已选择的不在时间段内的日期
                            if (this.model.unavailableDates && this.model.unavailableDates.length) {
                                this.model.unavailableDates = this.model.unavailableDates.filter(item => {
                                    return item >= beginDate && item <= endDate;
                                });
                            }
                        }
                        this.model.voucherDateBegin = beginDate;
                        this.model.voucherDateEnd = endDate;
                        // 更新日历配置
                        this.inDateOptionOpen.minDate = beginDate || formatDate(new Date(), 'yyyy-MM-dd');
                        this.inDateOptionOpen.maxDate = endDate;
                    },
                },
                // 不可用日期
                unavailableDates: '',
                inDateOptionOpen: {
                    allowInput: false,
                    minDate: that.model.voucherDateBegin || formatDate(new Date(), 'yyyy-MM-dd'),
                    maxDate: that.model.voucherDateEnd,
                    dateFormat: 'yyyy-MM-dd',
                    mode: 'multiple',
                    inline: true,
                    onChange: (dates) => {
                        if (Array.isArray(dates)) {
                            this.model.unavailableDates = dates.map(i => {
                                return formatDate(i, 'yyyy-MM-dd');
                            })
                        } else {
                            this.model.unavailableDates = [];
                        }
                    },
                    clickOpens: true
                },
                // 可用日期是否全选
                validWeekCheckedAll: false,
                validWeekRuleIds: [],
                foundFreeTicket: false,
                weeks: [{
                    text: '周一',
                    val: 'monday'
                }, {
                    text: '周二',
                    val: 'tuesday'
                }, {
                    text: '周三',
                    val: 'wednesday'
                }, {
                    text: '周四',
                    val: 'thursday'
                }, {
                    text: '周五',
                    val: 'friday'
                }, {
                    text: '周六',
                    val: 'saturday'
                }, {
                    text: '周日',
                    val: 'sunday'
                }],
                // 免票类型
                freeTicketTypes: [
                    {
                        name: '返佣免票',
                        id: 0
                    }, {
                        name: '广告位置换免票',
                        id: 1
                    }, {
                        name: '商家赠与免票',
                        id: 2
                    }, {
                        name: '商家参与活动免票',
                        id: 3
                    }, {
                        name: '其他',
                        id: 4
                    }],
                today: formatDate(new Date(), 'yyyy-MM-dd'),
                // 图片上传
                upload: {
                    maxImgLength: 5,
                    url: `${apiHost}${uploadImage}`,
                    maxSize: 1024 * 1024 * 2,
                    onBeforeUpload (file) {
                        let error = ''
                        if (file.size > that.upload.maxSize) {
                            error = '您选择了超过2M的图片，请上传小于2M的图片';
                        }
                        if (error) {
                            that.$message({
                                showClose: false,
                                message: error,
                                type: 'warning',
                                duration: 1000
                            });
                        }
                    },
                    onMaxLimit: function (e) {
                        that.$notify.error({
                            title: '错误',
                            message: '最多只能上传5张图片'
                        })
                    },
                    onSizeLimited: function (e) {
                        that.$message({
                            showClose: true,
                            message: '最多只能上传2M的图片',
                            type: 'error',
                            duration: 10000
                        })
                    },
                    onProgress (value) {
                        console.log('onProgress...');
                    },
                    onError (value) {
                        console.log('onError...');
                    },
                    onSuccess (value) {
                        if (value && value.file && value.file.url) {
                            let img = {imageName: value.file.name, imageUrl: value.file.url};
                            that.model.specialAuthPics.push(img);
                        }
                    },
                    onDelete (value) {
                        let url = ''
                        if (value.file) {
                            url = value.file.url;
                        } else {
                            url = value.url;
                        }
                        let _index = -1;
                        that.model.specialAuthPics.filter((item, index) => {
                            if (url === item.imageUrl) {
                                _index = index;
                            }
                        });
                        if (_index > -1) {
                            that.model.specialAuthPics.splice(_index, 1);
                        }
                    }
                },
                // 价格日历已经选择日期
                dateSelected: [],
                voucherDateBeginEnd: '',
                // 特殊费率列表
                invalidRatioList: {},
                // 价格日历模式下是否费率下降
                hasDeclined: false,
                // 价格日历模式下是否低于基准费率
                belowBase: false,
                // 座位图片
                seatUpload: {
                    maxImgLength: 1,
                    url: `${apiHost}${uploadImage}`,
                    maxSize: 1024 * 1024 * 2,
                    onBeforeUpload (file) {
                        let error = ''
                        if (file.size > that.upload.maxSize) {
                            error = '您选择了超过2M的图片，请上传小于2M的图片';
                        }
                        if (error) {
                            that.$message({
                                showClose: false,
                                message: error,
                                type: 'warning',
                                duration: 1000
                            });
                        }
                    },
                    onMaxLimit: function () {
                        that.$notify.error({
                            title: '错误',
                            message: '最多只能上传1张图片'
                        })
                    },
                    onSizeLimited: function () {
                        that.$message({
                            showClose: true,
                            message: '最多只能上传2M的图片',
                            type: 'error',
                            duration: 10000
                        })
                    },
                    onSuccess (value) {
                        if (value && value.file && value.file.url) {
                            that.model.seatImage = value.file.url;
                        }
                    },
                    onDelete () {
                        that.model.seatImage = '';
                    }
                },
                theatreTab: {changci: false, xiwei: false, changguan: false},
                // 剧场票价格日历配置
                price: {
                    // 是否可以编辑剧场票价格
                    canEditPrice: that.mode === 'new',
                    dateSelected: [],
                    // 合并成表格结构
                    priceTable: [],
                    priceSet: {},
                    single: false,
                    getInfoFun: function (day) {
                        let date = day.date;
                        let priceSet = that.price.priceSet;
                        let info = {texts: [], otherColor: true};
                        let item = priceSet[date];
                        if (item && item.length && item[0].mtPrice) {
                            info.texts.push('<span>已设置价格</span>');
                        }
                        return info;
                    },
                    onDaySelect: function (day) {
                        // 假如10号和11号有相同的价格说明，但是录入的价格不同时提示
                        let needUpdate = day && !that.price.canEditPrice;
                        if (needUpdate) {
                            that.price.dateSelected = [day.$day.date];
                        }
                        let needMerge = that.mergeTheatrePrice(null, true);
                        if (needMerge) {
                            that.$message.info(needMerge + '相同的价格说明，设置的价格不同，需要分开录入！');
                            that.price.dateSelected.splice(that.price.dateSelected.length - 1, 1);
                        }
                        if (needMerge || needUpdate) {
                            that.$nextTick(
                                () => {
                                    that.updateCalendar();
                                }
                            );
                        }
                    },
                    cancelCanEdit: function () {
                        that.price.canEditPrice = false;
                        that.price.dateSelected.length = 0;
                        that.price.priceTable = [];
                        that.$nextTick(
                            () => {
                                that.updateCalendar();
                            }
                        );
                    },
                    // 设置价格日历
                    savePrice: function () {
                        let priceTable = that.price.priceTable;
                        let hasNull  = (!priceTable || priceTable.length < 1) || priceTable.filter(i => { return !i.marketPrice || !i.mtPrice || !i.settlementPrice}).length;
                        if (hasNull) {
                            that.$message.info('请选择日期并填写完整价格再保存！');
                            return;
                        }
                        that.saveTheatreIno('price', true);
                    }
                },
                changci: {
                    // 是否可以编辑剧场票价
                    canEditPrice: that.mode === 'new',
                    dateSelected: [],
                    // 合并成表格结构
                    priceTable: [],
                    priceSet: {},
                    single: false,
                    getInfoFun: function (day) {
                        let date = day.date;
                        let priceSet = that.changci.priceSet;
                        let info = {texts: []};
                        let item = priceSet[date];
                        if (item && item.length) {
                            item.forEach(i => {
                                info.texts.push(`<span>场次 ${i.levelName}</span>`);
                            });
                        }
                        return info;
                    },
                    onDaySelect: function (day) {
                        // 重复场次开始时间则提示
                        let needUpdate = day && !that.changci.canEditPrice;
                        if (needUpdate) {
                            that.changci.dateSelected = [day.$day.date];
                        }
                        let needMerge = that.mergeTheatrePrice(that.changci.dateSelected, true, that.changci.priceSet, that.changci.priceTable, 'mappingRel');
                        if (needMerge) {
                            that.$message.info(needMerge + '相同的场次开始时间，需要分开录入！');
                            that.changci.dateSelected.splice(that.changci.dateSelected.length - 1, 1);
                        }
                        if (needMerge || needUpdate) {
                            that.$nextTick(
                                () => {
                                    that.updateCalendar();
                                }
                            );
                        }
                    },
                    cancelCanEdit: function () {
                        that.changci.canEditPrice = false;
                        that.changci.dateSelected.length = 0;
                        that.changci.priceTable = [];
                        that.$nextTick(
                            () => {
                                that.updateCalendar();
                            }
                        );
                    },
                    // 设置价格日历
                    savePrice: function () {
                        let priceTable = that.changci.priceTable;
                        let hasNull  = (!priceTable || priceTable.length < 1) || priceTable.filter(i => { return !i.levelName || !i.mappingRel}).length;
                        if (hasNull) {
                            that.$message.info('请选择日期并填写完整信息再保存！');
                            return;
                        }
                        that.saveTheatreIno('changci');
                    }
                },
                // 剧场票价格日历配置
                xiwei: {
                    canEditPrice: that.mode === 'new',
                    dateSelected: [],
                    // 合并成表格结构
                    priceTable: [],
                    priceSet: [],
                    single: false,
                    getInfoFun: function (day) {
                        let date = day.date;
                        let priceSet = that.xiwei.priceSet;
                        let info = {texts: []};
                        let item = priceSet[date];
                        if (item && item.length) {
                            item.forEach(i => {
                                info.texts.push(`<span>${i.levelName}</span>`);
                            });
                        }
                        return info;
                    },
                    onDaySelect: function (day) {
                        // 重复坐席位置则提示
                        let needUpdate = day && !that.xiwei.canEditPrice;
                        if (needUpdate) {
                            that.xiwei.dateSelected = [day.$day.date];
                        }
                        let needMerge = that.mergeTheatrePrice(that.xiwei.dateSelected, true, that.xiwei.priceSet, that.xiwei.priceTable, 'mappingRel');
                        if (needMerge) {
                            that.$message.info(needMerge + '相同的坐席位置，需要分开录入！');
                            that.xiwei.dateSelected.splice(that.xiwei.dateSelected.length - 1, 1);
                        }
                        if (needMerge || needUpdate) {
                            that.$nextTick(
                                () => {
                                    that.updateCalendar();
                                }
                            );
                        }
                    },
                    cancelCanEdit: function () {
                        that.xiwei.canEditPrice = false;
                        that.xiwei.dateSelected.length = 0;
                        that.xiwei.priceTable = [];
                        that.$nextTick(
                            () => {
                                that.updateCalendar();
                            }
                        );
                    },
                    // 设置价格日历
                    savePrice: function () {
                        let priceTable = that.xiwei.priceTable;
                        let hasNull  = (!priceTable || priceTable.length < 1) || priceTable.filter(i => { return !i.levelName || !i.mappingRel}).length;
                        if (hasNull) {
                            that.$message.info('请选择日期并填写完整信息再保存！');
                            return;
                        }
                        that.saveTheatreIno('xiwei');
                    }
                },
                // 剧场票场馆区域tab
                changguan: {
                    canEditPrice: that.mode === 'new',
                    dateSelected: [],
                    // 合并成表格结构
                    priceTable: [],
                    priceSet: [],
                    single: false,
                    getInfoFun: function (day) {
                        let date = day.date;
                        let priceSet = that.changguan.priceSet;
                        let info = {texts: []};
                        let item = priceSet[date];
                        if (item && item.length) {
                            item.forEach(i => {
                                info.texts.push(`<span>${i.levelName}</span>`);
                            });
                        }
                        return info;
                    },
                    onDaySelect: function (day) {
                        // 重复坐席位置则提示
                        let needUpdate = day && !that.changguan.canEditPrice;
                        if (needUpdate) {
                            that.changguan.dateSelected = [day.$day.date];
                        }
                        let needMerge = that.mergeTheatrePrice(that.changguan.dateSelected, true, that.changguan.priceSet, that.changguan.priceTable, 'mappingRel');
                        if (needMerge) {
                            that.$message.info(needMerge + '相同的场馆位置，需要分开录入！');
                            that.changguan.dateSelected.splice(that.changguan.dateSelected.length - 1, 1);
                        }
                        if (needMerge || needUpdate) {
                            that.$nextTick(
                                () => {
                                    that.updateCalendar();
                                }
                            );
                        }
                    },
                    cancelCanEdit: function () {
                        that.changguan.canEditPrice = false;
                        that.changguan.dateSelected.length = 0;
                        that.changguan.priceTable = [];
                        that.$nextTick(
                            () => {
                                that.updateCalendar();
                            }
                        );
                    },
                    // 设置价格日历
                    savePrice: function () {
                        let priceTable = that.changguan.priceTable;
                        let hasNull  = (!priceTable || priceTable.length < 1) || priceTable.filter(i => { return !i.levelName || !i.mappingRel}).length;
                        if (hasNull) {
                            that.$message.info('请选择日期并填写完整信息再保存！');
                            return;
                        }
                        that.saveTheatreIno('changguan');
                    }
                },
                sortDialog: {
                    model: [],
                    show: false,
                    modelKey: '',
                    no: {changci: 1, xiwei: 2, changguan: 3},
                    sort: function (key) {
                        if (that.mode === 'readonly') {
                            return;
                        }
                        that.sortDialog.modelKey = key;
                        getMappingSort(that.extra.supplierId, that.extra.partnerDealId, that.sortDialog.no[key]).then((result) => {
                            if (result && result.data.length > 1) {
                                that.sortDialog.show = false;
                                that.sortDialog.model = result.data;
                                that.$nextTick(
                                    () => {
                                        that.sortDialog.show = true;
                                    }
                                );
                            } else {
                                that.$message.info('没有要调整排序的内容！');
                            }

                        }, (err) => {
                            that.$message.info(`获取排序信息出错： ${err.message}`);
                        });

                    },
                    save: function (model) {
                        that.sortDialog.show = false;
                        saveMappingSort(that.extra.supplierId, that.extra.partnerDealId,
                            that.sortDialog.no[that.sortDialog.modelKey], model).then((result) => {
                            if (result && result.data.length > 1) {
                                that.$message.success('调整排序成功！');
                                that.fetchTheatreInfo(false, that.sortDialog.modelKey);
                            }
                        }, (err) => {
                            that.$message.info(`调整排序出错： ${err.message}`);
                        });
                    }
                }
            }
        },
        watch: {
            // 费率变化
            'model.baseMsRatioSnapshot': function () {
                if (this.model) {
                    if (!this.model.useDateMode || this.model.useDateMode === '0') {
                        this.ratioCheck();
                    } else {
                        this.calendarRadioCheck();
                    }
                }
            },
            // 监听是否剧场票
            'model.ticketPriceType': function (value) {
                this.model.IAmTheatre = value === 1 || value === '1';
                if (this.model.IAmTheatre) {
                    this.model.useDateMode = '1';
                    // 退款规则不支持部分退，只能一次退完
                    if (this.model.refundType !== 4 && this.model.refundType !== 3) {
                        this.model.refundType = 4;
                    }
                    this.model.stockType = 2
                }
            },
            // 剧场票的价格日历tab
            'price.dateSelected': function (newVal) {
                this.mergeTheatrePrice(newVal);
            },
            // 剧场票的场次tab
            'changci.dateSelected': function () {
                this.mergeTheatrePrice(this.changci.dateSelected, false, this.changci.priceSet, this.changci.priceTable, 'mappingRel');
            },
            // 剧场票的席位tab
            'xiwei.dateSelected': function () {
                this.mergeTheatrePrice(this.xiwei.dateSelected, false, this.xiwei.priceSet, this.xiwei.priceTable, 'mappingRel');
            },
            // 剧场票的场馆区域tab
            'changguan.dateSelected': function () {
                this.mergeTheatrePrice(this.changguan.dateSelected, false, this.changguan.priceSet, this.changguan.priceTable, 'mappingRel');
            },
            // 监听若产品id和供应商id同时有则初始化剧场票信息
            'extra.partnerDealId': function () {
                this.fetchTheatreInfo();
            },
            // 监听若产品id和供应商id同时有则初始化剧场票信息
            'extra.supplierId': function () {
                this.fetchTheatreInfo();
            },
            // 免票类型
            'model.freeTicketType': function () {
                this.updateFreeType();
            },
            model: async function () {
                // 初始化特批文件
                if (this.model.specialAuthPics && this.model.specialAuthPics.length > 0) {
                    this.model.specialAuthPics.forEach((item) => {
                        this.model.specialAuthPicsShow.push({
                            name: item.imageName,
                            url: item.imageUrl
                        });
                    });
                }
                // 初始化坐席图片
                if (this.model.seatImage) {
                    this.model.seatImageShow.push({
                        name: '座位图片',
                        url: this.model.seatImage
                    });
                }
            }
        },
        computed: {
            ...mapGetters(['account']),
            ratioShow () {
                this.ratioCheck();
                let _ratio = this.ratio > 0 ? this.ratio : 0;
                // 需求：若没上传过特批附件才进行设置
                if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                    this.model.needSpecialAuthFile = Math.floor(this.ratio) === 0;
                }
                return _ratio;
            },
            ratio () {
                let _ratio = this.correctRatio(this.model.mtPrice, this.model.settlementPrice, true);
                return _ratio;
            },
            ratioShowLocal () {
                this.ratioCheck();
                return this.ratioLocal > 0 ? this.ratioLocal : 0;
            },
            ratioLocal () {
                let _ratio = this.correctRatio(this.modelLocal.mtPrice, this.modelLocal.settlementPrice, true);
                return _ratio;
            }
        },
        props: {
            // 数据模型
            model: {
                type: Object,
                required: true
            },
            // 供应商信息
            extra: {
                type: Object,
                required: true
            },
            // 编辑方式
            mode: {
                type: String,
                required: false
            },
            isTuan: {
                type: Boolean,
                default: false
            },
            readonly: Boolean
        },
        methods: {
            // 拉取价格日历
            async pullPrice () {
                try {
                    const res = await asyncTicket(this.extra.supplierId, this.model.partnerDealId)
                    if (res.status === 0) {
                        if (res.data && res.data.length && res.data.length > 0) {
                            this.model.dayPriceStockRules = res.data;
                            // 重新计算费率
                            this.calendarRadioCheck()
                            this.updateCalendar()
                        } else {
                            throw new Error("拉取价格日历失败");
                        }
                    } else {
                        throw new Error("拉取价格日历失败");
                    }

                } catch (e) {
                    this.$alert({
                        title: '错误',
                        message: '拉取价格日历数据失败',
                        showCancelButton: false,
                        closeOnClickModal: false
                    })
                }


            },
            // 模式改变时改为不限库存
            dateModeChange () {
                this.model.stockType = 1;
                if (this.model.useDateMode === '0') {
                    this.ratioCheck();
                } else {
                    this.calendarRadioCheck();
                }
                if (this.mode === 'new'
                    && this.model.useDateMode === '1'
                    && !this.model.ticketCategory.ticket.ticketId
                    && this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice
                    && !this.modelLocal.marketPrice) {
                    this.modelLocal.marketPrice = this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice
                }
                // 直连价格日历模式，使用日库存默认
                if (this.mode === 'new'
                    && this.extra.isDirectDeal
                    && !this.model.IAmTheatre
                    && this.model.useDateMode === '1') {
                    this.model.stockType = 2
                }
            },
            // 全选可用日期
            selectAllWeek () {
                let checked = Boolean(this.validWeekCheckedAll);
                let week = this.model.validWeekRule;
                Object.keys(week).forEach((key) => {
                    week[key] = checked;
                });
            },
            // 不存在没选择的
            isAllWeekSelected () {
                let keysArr = Object.keys(this.model.validWeekRule);
                let out = keysArr.filter(item => !this.model.validWeekRule[item]).length < 1;
                this.validWeekCheckedAll = out;
            },
            //  删除一个不可用日期
            deleteUnavailableDates (i) {
                let index = this.model.unavailableDates.indexOf(i);
                if (index > -1) {
                    this.model.unavailableDates.splice(index, 1);
                }
            },
            // 重置不可用日期
            resetUnavailableDates () {
                this.model.unavailableDates = [];
            },
            // 全选子账户
            selectAllAccounts (select) {
                this.subAccountAll = !select;
                if (!this.subAccountAll) {
                    this.model && (this.model.bindedBizAccountId = []);// eslint-disable-line
                } else {
                    this.model && (this.model.bindedBizAccountId = []);// eslint-disable-line
                    this.subAccounts.forEach((item) => {
                        if (this.ticketSubAccount(item)) {
                            this.model && this.model.bindedBizAccountId.push(item.accountId);// eslint-disable-line
                        }
                    });
                }
            },
            // 是否显示
            ticketSubAccount (account, type) {
                let productType = account && account.authInfo && account.authInfo.ticketAuth && account.authInfo.ticketAuth.productType || [];
                if (type === 'all') {
                    return productType.indexOf(1) > -1;
                }
                return productType.indexOf(2) > -1;
            },
            // 获取子账户
            getSubAccounts () {
                // 超级账户才有子账户
                if (this.extra.isBD || this.account.accountType === 1) {
                    getSubAccounts(this.extra.supplierId)
                        .then((result) => {
                            if (result.data && result.data.accountInfoList) {
                                this.subAccounts = result.data.accountInfoList || [];
                                this.subAccounts = this.subAccounts.filter((item) => {
                                    return item && item.businessType && item.businessType.ticket;
                                });
                            }
                        }, (err) => {
                            this.$message.error(`获取子账户失败 ${err.message}`);
                        });
                } else if (!this.extra.isBD && this.model) {
                    this.model.bindedBizAccountId = [this.account.userId];
                }
            },
            // 免票类型切换
            updateFreeType () {
                if (this.model.freeTicketType === 0) {
                    this.model.associatedContractList = this.model.associatedContractList || [];
                    if (this.extra.supplierId) {
                        getCommissionStatement(this.extra.supplierId)
                            .then((json) => {
                                if (json.status === 0) {
                                    let data = json.data;
                                    this.model.associatedContractList = data.map(function (item, index) {
                                        item.showName = item.ruleName + '(' + item.statementPeriodStart + '至' + item.statementPeriodEnd + ')';
                                        return item;
                                    });
                                } else {
                                    this.$message.error(json.message || '获取信息出错');
                                }
                            }, (err) => {
                                this.$message.error(`获取免票类型失败 ${err.message}`);
                            });
                    }
                } else if (this.model.freeTicketType === 2 || this.model.freeTicketType === 3 || this.model.freeTicketType === 4) {
                    this.model.freeTicketAssociatedAccount = '';
                }
            },
            updateStatements () {
                if (this.model.freeTicketType === 0) {
                    let statement = {};
                    this.model.associatedContractList.forEach((item, index) => {
                        if (!statement.statementId && (item.statementId + '') === (this.model.statementId + '')) {
                            statement = item;
                        }
                    });
                    this.model.freeTicketAssociatedAccount = statement.statementId;
                    this.model.freeTicketAssociatedDetail = statement.showName;
                }
            },
            // 查询基础费率
            getMsRatio () {
                if (this.model.ticketCategory) {
                    this.$emit('updateMsRatio');
                }
            },
            // 计算费率: notCode，true表示用户输入，否则为代码调用
            correctRatio(mtPrice, settlementPrice, notCode) {
                if (mtPrice === null || mtPrice === undefined) return null;
                try {
                    let price = new Big(mtPrice);
                    let commission = price.minus(settlementPrice);
                    let ratio = commission.div(mtPrice).mul(100);
                    ratio = this.toFixedFloor(ratio);
                    if (notCode) {
                        // 需求：若没上传过特批附件才进行设置
                        if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                            this.model.needSpecialAuthFile = ratio === 0;
                        }
                    }
                    // 解决：如mtPrice为33，settlementPrice为17应该得0.4848，*100 却出现48.480000000000004
                    // 解决：如mtPrice为33，settlementPrice为20应该得0.3939，*10000/100 出现39.38999999999999
                    // (117-101)/117 = 0.1367 *100还是*10000/100 都有问题
                    // let _ratio100 = ratio * 100;
                    // let _ratio1000 = ratio * 10000 / 100;
                    // ratio = _ratio100.toString().length > _ratio1000.toString().length ? _ratio1000: _ratio100;
                    return ratio;
                } catch (e) {
                    return 0
                }
            },
            async addDayPrice(query = {}, selected = []) {
                // 特殊费率弹窗提示
                if ((this.ratioLocal > 50 || this.modelLocal.settlementPrice && this.hasDeclined)
                    || (this.modelLocal.settlementPrice && this.ratioLocal < this.model.baseMsRatioSnapshot * 100)) {
                    if (!this.isTuan) {
                        await this.$alert_html({
                            title: '重要提示',
                            message: '提交价格的费率存在降低/没有达到普通费率底线，更新提交后，<b>会进入人工费率审核（预计24小时内，审核完毕），审核通过后才可以上线</b>',
                            showCancelButton: false,
                            closeOnClickModal: false
                        })
                    }
                }

                let priceInfo = this.model.dayPriceStockRules;
                if (!priceInfo) {
                    priceInfo = this.model.dayPriceStockRules = [];
                }
                if (!selected.length) {
                    this.$message({
                        showClose: true,
                        message: '请先选择日期',
                        type: 'error',
                        duration: 1400
                    });
                    return;
                }
                if (this.model.stockType === 2 && !this.modelLocal.stock) {
                    this.$message({
                        showClose: true,
                        message: '请设置日库存',
                        type: 'error',
                        duration: 1400
                    });
                    return;
                }

                // 日库存模式需要存储已售，拆开存储
                let dayStock = [];
                selected.forEach((date) => {
                    priceInfo.every((item) => {
                        let dates = item.dates || [];
                        let pos = dates.indexOf(date);
                        if (pos > -1) {
                            // 如果日库存模式，将已售保留下来
                            if (parseInt(this.model.stockType, 10) === 2) {
                                let oneStack = JSON.parse(JSON.stringify(query));
                                oneStack.dates = [date];
                                oneStack.sold = item.sold;
                                dayStock.push(oneStack);
                            }
                            dates.splice(pos, 1);
                        }
                        return pos === -1;
                    });
                });

                // 日库存模式，剔除已经处理过的日期
                if (parseInt(this.model.stockType, 10) === 2) {
                    selected = selected.filter(date => {
                        for (let item of dayStock) {
                            let dates = item.dates || [];
                            let pos = dates.indexOf(date);
                            if (pos !== -1) return false;
                        }
                        return true
                    })
                }
                
                let msg = '';
                priceInfo.forEach((item1) => {
                    item1.dates.every((date2) => {
                        let isWrong = (date2 >= this.today);
                        if (query.settlementPrice === 0) {
                            isWrong = isWrong && (item1.settlementPrice !== 0);
                        } else {
                            isWrong = isWrong && (item1.settlementPrice === 0);
                        }

                        if (isWrong) {
                            msg = date2;
                        }
                        return !isWrong;
                    });
                });

                if (msg.length) {
                    this.$message({
                        showClose: true,
                        message: '不允许非0结算价与0结算价的录入在一个deal上',
                        type: 'error',
                        duration: 1400
                    });
                    return;
                }

                if (parseInt(this.model.stockType, 10) === 2) {
                    priceInfo = priceInfo.concat(dayStock);
                }

                let submitInfo = Object.assign({
                    dates: selected.concat()
                }, query);
                priceInfo.push(submitInfo);

                // 删除没有出发日期的
                this.model.dayPriceStockRules = priceInfo.filter((item) => {
                    return item.dates && item.dates.length;
                });
                selected.length = 0;
                this.calendarRadioCheck();
                this.updateCalendar();
            },

            updateCalendar() {
                eventBus.$emit('calendar-update');
            },

            // 有效期模式
            ratioCheck() {
                this.ratioInvalid = false;
                if (this.model) {
                    let msRatio = this.model.baseMsRatioSnapshot;
                    let ratioInvalid = false;
                    if (!this.model.useDateMode || this.model.useDateMode === '0') {
                        // ratioInvalid：1： 费率大于50；2： 美团价大于了门市价；3：低于基准 4：费率下降
                        if (this.ratio > 50) {
                            ratioInvalid = 1;
                        } else if (this.model.mtPrice > this.model.marketPrice) {
                            ratioInvalid = 2;
                        }
                        // 低于基准
                        if (msRatio && this.ratio && this.ratio < msRatio * 100) {
                            ratioInvalid = 3;
                        }
                        // 费率下降
                        if (this.model.onlineMsRatioPriceInfo &&
                            this.model.onlineMsRatioPriceInfo.oldMsRatio && this.ratio &&
                            this.model.onlineMsRatioPriceInfo.oldMsRatio * 100 > this.ratio) {
                            ratioInvalid = 4;
                        }
                    } else {
                        if (this.ratioLocal > 50) {
                            ratioInvalid = 1;
                        } else if (this.modelLocal.mtPrice > this.modelLocal.marketPrice) {
                            ratioInvalid = 2;
                        }
                        // 低于基准
                        if (msRatio && this.ratioLocal && this.ratioLocal < msRatio * 100) {
                            ratioInvalid = 3;
                        }
                    }
                    this.ratioInvalid = ratioInvalid;
                }
            },

            calendarRadioCheck() {
                // 价格日历模式
                if (this.model.useDateMode) {
                    this.belowBase = false;
                    this.hasDeclined = false;
                    // 需求：若没上传过特批附件才进行设置
                    if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                        this.model.needSpecialAuthFile = false;
                    }
                    if (this.model.dayPriceStockRules && this.model.dayPriceStockRules.length) {
                        let msRatio = this.model.baseMsRatioSnapshot;
                        // 整理价格 费率 为 特殊费率展示格式
                        let result = {};
                        this.foundFreeTicket = false
                        this.model.dayPriceStockRules.forEach((item) => {
                            let hasAfter = false;
                            item.dates.forEach((date) => {
                                if (date > this.today) {
                                    hasAfter = true;
                                    // 检查费率下降
                                    if (this.checkHistoryRatio(item, date, true)) {
                                        this.hasDeclined = true;
                                    }
                                }
                            });
                            if (!hasAfter) return;
                            // 判断免票(适配拉取价格日历规则）
                            if (parseInt(item.settlementPrice, 10) === 0) {
                                this.foundFreeTicket = true
                            }
                            // 小于底线费率才进行展示
                            let ratio = this.correctRatio(item.mtPrice, item.settlementPrice);
                            if (ratio === 0) {
                                // 需求：若没上传过特批附件才进行设置
                                if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                                    // 价格日历模式中如果存在0费率则需要上传特批附件
                                    this.model.needSpecialAuthFile = true;
                                }
                            }
                            // 如果是直连，并且新增不等于old，onlineMsRatioPriceInfo[date] || onlineMsRatioPriceInfo.oldMsRatio
                            // 获取old费率
                            if (ratio < msRatio * 100 && !(this.isDirectDeal && ratio === this.model.onlineMsRatioPriceInfo.oldMsRatio)) {
                                this.belowBase = true;
                                let tempKey = 'ratio_' + item.mtPrice + '_' + item.settlementPrice;
                                if (!result[tempKey]) {
                                    result[tempKey] = Object.assign({}, item);
                                    result[tempKey].ratio = ratio;
                                } else {
                                    result[tempKey].dates = result[tempKey].dates.concat(item.dates);
                                }
                            }
                        });
                        this.invalidRatioList = result;
                    }
                }
            },

            dayLock(day) {
                return Boolean(day.isBefore || day.isAfter || this.readonly)
            },

            onRemoveDate(selected) {
                let priceInfo = this.model.dayPriceStockRules;
                if (!priceInfo) {
                    priceInfo = this.model.dayPriceStockRules = [];
                }
                selected.forEach((date) => {
                    priceInfo.every((item) => {
                        let dates = item.dates || [];
                        let pos = dates.indexOf(date);
                        if (pos > -1) {
                            dates.splice(pos, 1);
                        }
                        return pos === -1;
                    });
                });

                this.model.dayPriceStockRules = priceInfo.filter((item) => {
                    return item.dates && item.dates.length;
                });
                this.calendarRadioCheck();
            },

            getTitle(date, item) {
                let title = [];
                let ratio = this.correctRatio(item.mtPrice, item.settlementPrice);

                title.push('日期' + date + '&nbsp;' + (item.subText ? '库存' + item.subText : ''));
                title.push('门市价' + item.marketPrice + '&nbsp;美团价' + item.mtPrice);
                title.push('结算价' + item.settlementPrice + '&nbsp;费率' + ratio + '%');
                return title.join('<br>');
            },

            getInfoFun (day) {
                let date = day.date;
                let priceInfo = this.model.dayPriceStockRules || [];
                let info = {};
                for (let i = 0, len = priceInfo.length; i < len; i++) {
                    let item = priceInfo[i];
                    let dates = item.dates;
                    if (date === dates || dates.indexOf(date) > -1) {
                        info = Object.assign({
                            texts: []
                        }, item);
                        delete info.dates;
                        break;
                    }
                }

                if (info.mtPrice) {
                    let items = info.texts;
                    info.title = this.getTitle(date, info);
                    items.push(`门市价:￥${info.marketPrice}  美团价:￥${info.mtPrice}`);
                    items.push(`结算价:￥${info.settlementPrice}`);
                    let ratio = this.correctRatio(info.mtPrice, info.settlementPrice);
                    // 检查费率是否下降
                    this.checkHistoryRatio(info, date);
                    // 费率下降
                    if (info.isDecline) {
                        items.push(`<span style="color:#ff4f28">费率:${ratio + '%⬇&nbsp;'}</span>(${(info.previousRate * 100).toFixed(2)}%)`);
                    } else if (this.model.baseMsRatioSnapshot && (ratio < this.model.baseMsRatioSnapshot * 100)) {
                        // 特殊费率
                        items.push(`<span style="color:#ff4f28">费率:${ratio + '%'}(特殊费率)</span>`);
                    } else {
                        items.push(`费率:${ratio + '%'}`);
                    }

                    let sold = parseInt(info.sold || '0');
                    let stockType = parseInt(this.model.stockType);
                    let stockText = '不限';
                    if (stockType === 2) {
                        if (info.stock > -1) {
                            stockText = info.stock.toString();
                        } else if (info.stock === -1) {
                            stockText = '不限';
                        } else {
                            stockText = '未设置';
                        }
                    } else if (stockType === 3) {
                        stockText = this.model.stock;
                    }
                    if (stockText) {
                        items.push(`已售/库存: ${sold}/${stockText}`);
                    }
                }
                return info;
            },
            // 检查历史费率，费率是否下降
            checkHistoryRatio (day, date, notSetResult) {
                if (this.model.onlineMsRatioPriceInfo && this.model.onlineMsRatioPriceInfo.dayPriceStockRules) {
                    if (day && date && (this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date] || this.model.onlineMsRatioPriceInfo.oldMsRatio)) {
                        if (((this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date] || this.model.onlineMsRatioPriceInfo.oldMsRatio) * 100).toFixed(4) > this.correctRatio(day.mtPrice, day.settlementPrice)) {
                            if (!notSetResult) {
                                day.isDecline = true;
                                day.previousRate = this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date] ? this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date].toFixed(4) : this.model.onlineMsRatioPriceInfo.oldMsRatio.toFixed(4);
                            }
                            return true;
                        }
                    }
                }
                return false;
            },
            // 根据获取数组中某个属性的集合
            getTheListAttrs (list, attr) {
                let result = [];
                if (Array.isArray(list)) {
                    list.forEach((item,) => {
                        result.push(item[attr]);
                    });
                }
                return result;
            },
            // 保存价格日历
            save () {
                let data;
                // if (!validate()) return;

                this.priceInfo = this.priceInfo || [];
                // 遍历每个日期
                this.dateSelected.forEach((date, index) => {
                    this.priceInfo.forEach((item) => {
                        let pos = item.dates.indexOf(date);
                        if (pos > -1) {
                            item.dates.splice(pos, 1);
                        }
                    });
                });
                data = Object.assign({}, this.modelLocal);
                data.dates = this.dateSelected.concat([]);
                this.priceInfo.push(data);
                // 删除没有出发日期的
                this.priceInfo = this.priceInfo.filter(function (item) {
                    return item.dates && item.dates.length;
                });
                this.model.dayPriceStockRules = this.priceInfo;
                this.dateSelected.length = 0;
                eventBus.$emit('calendar-reset')
            },
            toFixedFloor(num, length = 2) {
                let rate = Math.pow(10, length);
                let val = Number(num) * rate;
                val = Math.floor(val);
                return val / rate;
            },
            // 查询剧场票显示什么tab
            getAllMappingExt() {
                return getAllMappingExtType(this.extra.supplierId, this.extra.partnerDealId).then((result) => {
                    return result.data;
                });
            },
            // 获取演出信息
            fetchTheatreInfo(isClick, tabKey) {
                if (!this.model.IAmTheatre || !this.extra.isBD) {
                    return;
                }
                if (this.extra.partnerDealId && this.extra.supplierId) {
                    this.getAllMappingExt().then(response => {
                        if (!tabKey) {
                            getPriceBase(this.extra.supplierId, this.extra.partnerDealId).then((result) => {
                                if (result.data) {
                                    this.price.priceSet = result.data;
                                    this.mergeTheatrePrice();
                                    this.updateCalendar();
                                }
                            }, (err) => {
                                this.$message.info(`获取剧场票价格基本信息出错： ${err.message}`);
                            });
                        }
                        // 解决ui不更新问题
                        this.$nextTick(
                            () => {
                                if (Array.isArray(response)) {
                                    this.theatreTab.changci = response.includes(1);
                                    this.theatreTab.xiwei = response.includes(2);
                                    this.theatreTab.changguan = response.includes(3);
                                } else {
                                    this.theatreTab.changci = false;
                                    this.theatreTab.xiwei = false;
                                    this.theatreTab.changguan = false;
                                }
                            }
                        );
                        let mappingObj = [{no: 1, label: '场次', prop: 'changci'}, {no: 2, label: '席位', prop: 'xiwei'}, {no: 3, label: '场馆', prop: 'changguan'}];
                        mappingObj.forEach( i=> {
                            if (response && response.length && response.includes(i.no)) {
                                let need = !tabKey || i.prop === tabKey;
                                need && getMappingExt(this.extra.supplierId, this.extra.partnerDealId, i.no).then((result) => {
                                    if (result.data) {
                                        this[i.prop].priceSet = result.data;
                                    }
                                    this.mergeTheatrePrice(this[i.prop].dateSelected, false, this[i.prop].priceSet, this[i.prop].priceTable, 'mappingRel');
                                    this.updateCalendar();
                                }, (err) => {
                                    this.$message.info(`获取剧场票${i.label}出错： ${err.message}`);
                                });
                            }
                        });
                    });
                } else {
                    if (isClick) {
                        this.$message.info('缺少供应商或产品信息');
                    }
                }
            },
            /***
             * 合并原始数据进行展示
             * @param dates 日历控件选中的日期
             * @param isMsg  是否只验证重复信息
             * @param priceSetParam 传入的原始数据
             * @param tableData 整理完数据需要放的变量
             * @param priceSet 接口返回的原始数据
             * @returns {string}
             */
            mergeTheatrePrice(dates, isMsg, priceSetParam, tableData, repeatProp = 'priceDesc') {
                let tool = {};
                let msg = {};
                tableData = tableData || this.price.priceTable;
                priceSetParam = priceSetParam || this.price.priceSet;
                dates = dates || this.price.dateSelected;
                if (!isMsg) {
                    tableData.length = 0;
                }
                let priceSet = Object.assign({}, priceSetParam);
                for (let date of dates) {
                    let price = priceSet[date];
                    if (price && price.length) {
                        for (let pp of price) {
                            let p = Object.assign({}, pp);
                            // 相同价格，不同价格说明也可以一次录入
                            let samePrice = tool[p[repeatProp]] && (repeatProp === 'priceDesc' && tool[p[repeatProp]].marketPrice === p.marketPrice && tool[p[repeatProp]].mtPrice === p.mtPrice && tool[p[repeatProp]].settlementPrice === p.settlementPrice || repeatProp === 'mappingRel'
                            && tool[p[repeatProp]].levelName === p.levelName);
                            // 重复则把重复日期放入指定价格说明行
                            if (tool[p[repeatProp]] || samePrice) {
                                if (!isMsg) {
                                    tool[p[repeatProp]].dates.push({date: date, id: p.id});
                                }
                                if (!samePrice) {
                                    msg[`${tool[p[repeatProp]].dates[0].date}、${date}`] = 1;
                                }
                            } else {
                                p.dates = [{date: date, id: p.id}];
                                if (p[repeatProp]) {
                                    tool[p[repeatProp]] = p;
                                }
                                if (!isMsg) {
                                    tableData.push(p);
                                }
                            }
                        }
                    }
                }
                let result = Object.keys(msg).join('，');
                if (result) {
                    if (!isMsg) {
                        dates.length = 0;
                        this.updateCalendar();
                        this.$message.info(`${result}相同信息，需要分开录入！`)
                    }
                    return result;
                }
            },
            // 前台刷新剧场票priceSet
            refreshPriceSet() {
                this.$nextTick(
                    () => {
                        this.updateCalendar();
                    }
                );
            },
            // 保存剧场票相关信息
            saveTheatreIno(priceSet, isPrice) {
                if (this.model.IAmTheatre) {
                    let price = this.prepareTheatreInfo(priceSet, isPrice);
                    if (isPrice) {
                        savePriceBase(this.extra.supplierId, this.extra.partnerDealId, price).then((result) => {
                            if (result && result.data) {
                                Object.keys(result.data).forEach(i => {
                                    this[priceSet].priceSet[i] = result.data[i];
                                });
                                this[priceSet].dateSelected = [];
                                this.refreshPriceSet();
                                this.$message.success('保存成功!');
                            }
                        }, (err) => {
                            this.$message.error(`保存剧场票价格基本信息出错： ${err.message}`);
                        });
                    } else {
                        let mappingObj = {changci:{no: 1, label: '场次', prop: 'changci'},
                            xiwei: {no: 2, label: '席位', prop: 'xiwei'},
                            changguan:{no: 3, label: '场馆', prop: 'changguan'}};
                        saveMappingExt(this.extra.supplierId, this.extra.partnerDealId, mappingObj[priceSet].no, price).then((result) => {
                            if (result && result.data) {
                                Object.keys(result.data).forEach(i => {
                                    this[priceSet].priceSet[i] = result.data[i];
                                });
                                this[priceSet].dateSelected = [];
                                this.refreshPriceSet();
                                this.$message.success('保存成功!');
                            }
                        }, (err) => {
                            this.$message.error(`保存剧场票${mappingObj[priceSet].label}出错： ${err.message}`);
                        });
                    }
                }
            },
            // 整理原始剧场票信息
            prepareTheatreInfo(priceSet, isPrice) {
                let result = [];
                let priceTable = this[priceSet].priceTable;
                let dateSelected = this[priceSet].dateSelected;
                if (priceTable && priceTable.length) {
                    for (let price of priceTable) {
                        if (price && price.dates && price.dates.length) {
                            for (let ids of price.dates) {
                                if (dateSelected.indexOf(ids.date) > -1 ) {
                                    if (isPrice) {
                                        result.push({
                                            id: ids.id,
                                            marketPrice: price.marketPrice,
                                            mtPrice: price.mtPrice,
                                            settlementPrice: price.settlementPrice
                                        });
                                    } else {
                                        result.push({
                                            id: ids.id,
                                            levelSeq: price.levelSeq,
                                            levelName: price.levelName,
                                            mappingRel: price.mappingRel
                                        });
                                    }

                                }
                            }
                        }
                    }
                }
                return result;
            },
            // 整理原始剧场票信息
            prepareTheatreInfo1(priceSet, isPrice) {
                let result = [];
                let price_Set = this[priceSet].priceSet;
                let dateSelected = this[priceSet].dateSelected;
                Object.keys(price_Set).forEach(i => {
                    let item = price_Set[i];
                    if (dateSelected.indexOf(i) > -1 && item && item.length) {
                        for (let price of item) {
                            let modelItem = isPrice ?
                                { id: price.id, marketPrice: price.marketPrice, mtPrice: price.mtPrice, priceDesc: price.priceDesc, settlementPrice: price.settlementPrice}
                                : {id: price.id, levelSeq: price.levelSeq, levelName: price.levelName, mappingRel: price.mappingRel};
                            result.push(modelItem);
                        }
                    }
                });
                return result;
            }
        },
        async mounted () {
            // 团购没有子账号信息
            if (!this.isTuan) {
                this.getSubAccounts();
            }
            this.getMsRatio();
            this.fetchTheatreInfo();
            // 直连检查
            if (this.extra.isDirectDeal) {
                try {
                    const res = await queryCalendar(this.extra.supplierId)
                    if (res.status === 0) {
                        this.canPullPrice = Boolean(res.data.priceUrl)
                    }
                } catch (e) {
                    console.log(e)
                }
            }

            // 可用日期星期全选
            // 不存在没选择的
            this.$watch(
                function () {
                    let out = false;
                    if (this.model.validWeekRule) {
                        let keysArr = Object.keys(this.model.validWeekRule);
                        out = keysArr.filter(item => !this.model.validWeekRule[item]).length < 1;
                        this.hasWeekOne = keysArr.filter(item => this.model.validWeekRule[item]).length > 0;
                    }
                    this.validWeekCheckedAll = out;
                    return out;
                },
                function (newVal, oldVal) {
                    this.validWeekCheckedAll = newVal;
                }
            );

            // 监听有效期时间段
            this.$watch(
                function () {
                    let out = this.model.voucherDateBegin && this.model.voucherDateEnd ? `${this.model.voucherDateBegin} ~ ${this.model.voucherDateEnd}` : '';
                    return out;
                },
                function (newVal, oldVal) {
                    this.voucherDateBeginEnd = newVal;
                    this.inDateOptionOpen.minDate = this.model.voucherDateBegin;
                    this.inDateOptionOpen.maxDate = this.model.voucherDateEnd;
                }
            );
            // 监听不可用日期
            this.$watch('model.unavailableDates',
                function (val) {
                    if (val && val.length) {
                        this.unavailableDates = val.join(' ~ ');
                    } else {
                        this.unavailableDates = '';
                    }
                }
            );
            // 监听价格日历选中日期
            this.$watch('dateSelected',
                function (newVal, oldVal) {
                    const date = newVal[newVal.length - 1]
                    for (let rule of this.model.dayPriceStockRules) {
                        if (rule.dates.indexOf(date) !== -1) {
                            this.modelLocal.mtPrice = rule.mtPrice
                            this.modelLocal.marketPrice = rule.marketPrice
                            this.modelLocal.settlementPrice = rule.settlementPrice
                            this.modelLocal.stock = rule.stock
                            break
                        }
                    }
                }
            );
        }
    }
</script>



// WEBPACK FOOTER //
// Price.vue?4dd36def